import React from 'react';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';

export function SocialLinks() {
  return (
    <Wrapper>
      <a href="https://www.linkedin.com/company/visually-io">
        <StaticImage
          src="linkedinicon.png"
          alt="LinkedIn"
          quality={100}
          objectFit="contain"
          height={50}
        />
      </a>
      <a href="https://twitter.com/Visuallyio/">
        <StaticImage
          src="twttericon.png"
          alt="Twitter"
          quality={100}
          objectFit="contain"
          height={40}
        />
      </a>
      <a href="https://www.youtube.com/@visually4198">
        <StaticImage
          src="youtubeicon.png"
          alt="Youtube"
          quality={100}
          objectFit="contain"
          height={40}
        />
      </a>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 4rem);
  grid-gap: 3rem;
  align-items: center;
`;
